import { useState, useCallback } from "react";

export type UploadStatus = "idle" | "uploading" | "success" | "error";

interface UseFileUploadReturn {
  status: UploadStatus;
  error: string | null;
  execute: (uploadFn: () => Promise<any>) => Promise<any>;
  reset: () => void;
}

export const useFileUpload = (): UseFileUploadReturn => {
  const [status, setStatus] = useState<UploadStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const execute = useCallback(async (uploadFn: () => Promise<any>) => {
    setStatus("uploading");
    setError(null);

    try {
      const result = await uploadFn();
      setStatus("success");
      return result;
    } catch (err: any) {
      setStatus("error");
      setError(err?.message || err?.Message || "Upload failed");
      throw err;
    }
  }, []);

  const reset = useCallback(() => {
    setStatus("idle");
    setError(null);
  }, []);

  return { status, error, execute, reset };
};
